import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { useAppStore } from "../../../../stores/RootStore";
import { FShift } from "../../../../types/types";
import { ScrollArea } from "../../../../ui/ScrollArea/ScrollArea";
import { Separator } from "../../../../ui/Separator";
import Spinner from "../../../../ui/Spinner/Spinner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../../ui/Tabs/Tabs";
import ShiftBreaks from "./tabs/breaksTab/ShiftBreaks";
import ShiftSettingsTab from "./tabs/ShiftSettingsTab";
import { TbArrowBack, TbArrowLeft } from "react-icons/tb";

const ShiftItem = () => {
  const { id } = useParams();
  const shifts = useAppStore((store) => store.shifts);
  const [loading, setLoading] = useState(true);
  const [currentShift, setCurrentShift] = useState<FShift>();

  useEffect(() => {
    if (!id || shifts.length == 0) return;
    setLoading(true);
    setCurrentShift(shifts.find((shift) => id === shift.id)!);
  }, [id, shifts]);

  useEffect(() => {
    if (!currentShift) return;

    setLoading(false);
  }, [currentShift]);

  return loading || shifts.length == 0 ? (
    <Spinner />
  ) : (
    <ScrollArea className="w-full">
      <div className="flex flex-col w-full h-full max-w-[800px]">
        <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
          <div className="flex flex-col space-y-1">
            <NavLink to={"/data/shifts"} className="text-sm flex gap-2 items-center text-muted-foreground"><TbArrowLeft />{t("shifts")}</NavLink>
            <span className="text-2xl font-semibold">{t('editing_shift')}</span>
          </div>
        </div>
        <Tabs defaultValue="settings" className="px-6">
          <TabsList className="w-full flex-none h-10 justify-between px-2 rounded">
            <div className="flex">
              <TabsTrigger value="settings">{t("common_info")}</TabsTrigger>
              <TabsTrigger value="breaks">{t("breaks")}</TabsTrigger>
            </div>
          </TabsList>

          <TabsContent value="settings">
            <ShiftSettingsTab id={id} currentShift={currentShift} />
          </TabsContent>
          <TabsContent value="breaks">
            <ShiftBreaks id={id} currentShift={currentShift} />
          </TabsContent>
        </Tabs>
      </div>
    </ScrollArea>
  );
};

export default ShiftItem;


